import React, { Component } from "react"
import { translate } from "react-translate"
import {
  Button,
  Modal,
  Form,
  Segment,
  Dropdown,
  Input,
  Label,
  Icon
} from "semantic-ui-react"
import "./ModalMateriaux.css"
import _ from "lodash"

const options = [
  { key: 1, text: "text_dropdown_kg", value: 1 },
  { key: 2, text: "text_dropdown_m²", value: 2 },
  { key: 3, text: "text_dropdown_u", value: 3 },
  { key: 4, text: "text_dropdown_hr", value: 4 },
  { key: 5, text: "text_dropdown_ml", value: 5 },
  { key: 6, text: "text_dropdown_l", value: 6 }
]

class ModalMateriaux extends Component {
  constructor(props) {
    super(props)
    this.state = { toggle: 1, modalOpen: false }
    this.eventHandler = this.eventHandler.bind(this)
  }

  handleOpen = () => this.setState({ modalOpen: true })

  handleClose = () => this.setState({ modalOpen: false })

  componentWillMount() {
    let { t } = this.props
    var optionsCopy = _.clone(options)
    optionsCopy = _.map(optionsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      options: optionsCopy
    })
  }
  eventHandler(event) {
    this.setState({
      toggle: event
    })
  }
  render() {
    var callback = this.props.onSave || function() {}
    let { t } = this.props
    return (
      <Modal
        trigger={
          <Button id="bouttonEntete2" onClick={this.handleOpen}>
            {" "}
            <Icon className="add" id="iconDisplayAdd" name="add" />
            <p className="btnEnteteText">{t("button_modal_create")}</p>
          </Button>
        }
        open={this.state.modalOpen}
        onClose={this.handleClose}
        id="createMaterialModal"
      >
        <Modal.Header id="createMaterial">
          {this.state.toggle == 1
            ? t("title_modal_material")
            : this.state.toggle == 2
              ? t("title_modal_workforce")
              : t("title_modal_work")}
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form>
              <Form.Field className="fieldForms">
                <label className="modalMargin">{t("label_modal_name")}</label>
                <Input
                  type="text"
                  placeholder={t("placeholder_modal_name")}
                  onChange={(e, val) => this.setState({ name: val.value })}
                />
              </Form.Field>
              <Form.Field
                stackable
                mobile={16}
                tablet={8}
                computer={4}
                className="fieldForms"
              >
                <label className="modalMargin">{t("label_modal_type")}</label>
                <Button.Group fluid id="">
                  <Button
                    active={this.state.toggle == 1}
                    onClick={() => this.eventHandler(1)}
                  >
                    {t("label_modal_category_material")}
                  </Button>
                  <Button
                    active={this.state.toggle == 2}
                    onClick={() => this.eventHandler(2)}
                  >
                    {t("label_modal_category_workforce")}
                  </Button>
                  <Button
                    active={this.state.toggle == 3}
                    onClick={() => this.eventHandler(3)}
                  >
                    {t("label_modal_category_work")}
                  </Button>
                </Button.Group>
              </Form.Field>

              {this.state.toggle == 1 ? (
                <Form.Group widths="equal" id="createMaterialModalFieldGroup">
                  <Form.Field className="fieldForms">
                    <label className="modalMargin">
                      {t("label_modal_unity")}
                    </label>
                    <Dropdown
                      selection
                      options={this.state.options || []}
                      placeholder="U"
                      onChange={(e, val) => this.setState({ unité: val.value })}
                    />
                  </Form.Field>
                  <Form.Field className="fieldForms">
                    <label className="modalMargin">
                      {t("label_modal_price_sec")}
                    </label>
                    <Input
                      labelPosition="right"
                      type="text"
                      placeholder="0,00"
                      className="fieldForms"
                      onChange={(e, val) =>
                        this.setState({ prixSec: val.value })
                      }
                    >
                      <input />
                      <Label id="inputMontantLabelMateriaux">
                        {t("label_modal_€")}
                      </Label>
                    </Input>
                  </Form.Field>
                  <Form.Field className="fieldForms">
                    <label className="modalMargin">
                      {t("label_modal_price_ht")}
                    </label>
                    <Input
                      labelPosition="right"
                      type="text"
                      placeholder=""
                      onChange={(e, val) => this.setState({ price: val.value })}
                    >
                      <input />
                      <Label id="inputMontantLabelMateriaux">
                        {t("label_modal_€")}
                      </Label>
                    </Input>
                  </Form.Field>
                </Form.Group>
              ) : this.state.toggle == 2 ? (
                <Form.Group>
                  <Form.Field className="fieldForms">
                    <label>{t("label_modal_unity")}</label>
                    <Dropdown
                      selection
                      options={this.state.options || []}
                      placeholder="U"
                      onChange={(e, val) => this.setState({ unité: val.value })}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>{t("label_modal_price_ht")}</label>
                    <Input
                      labelPosition="right"
                      type="text"
                      placeholder=""
                      onChange={(e, val) => this.setState({ price: val.value })}
                    >
                      <input />
                      <Label>{t("label_modal_€")}</Label>
                    </Input>
                  </Form.Field>
                </Form.Group>
              ) : (
                <Form.Group id="blockOuvrage">
                  <Form.Field>
                    <Form.TextArea
                      label={t("label_modal_description")}
                      placeholder={t("placeholder_modal_description")}
                      onChange={(e, val) =>
                        this.setState({ description: val.value })
                      }
                    />
                  </Form.Field>
                  <Segment id="blockChampInput">
                    <Form.Field>
                      <label>{t("input_modal_material")}</label>
                      <Input
                        labelPosition="right"
                        type="text"
                        placeholder={t("placeholder_modal_material")}
                        onChange={(e, val) =>
                          this.setState({ materiel: val.value })
                        }
                      >
                        <input />
                      </Input>
                    </Form.Field>{" "}
                    <Form.Field>
                      <label>{t("input_modal_workforce")}</label>
                      <Input
                        labelPosition="right"
                        type="text"
                        placeholder={t("placeholder_modal_workforce")}
                        onChange={(e, val) =>
                          this.setState({ mainD: val.value })
                        }
                      >
                        <input />
                      </Input>
                    </Form.Field>
                  </Segment>
                  <Segment id="blockChampInput">
                    <Form.Field>
                      <label>{t("label_modal_unity")}</label>
                      <Dropdown
                        selection
                        options={this.state.options || []}
                        placeholder="U"
                        onChange={(e, val) =>
                          this.setState({ unité: val.value })
                        }
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{t("label_modal_price_ht")}</label>
                      <Input
                        labelPosition="right"
                        type="text"
                        placeholder=""
                        onChange={(e, val) =>
                          this.setState({ price: val.value })
                        }
                      >
                        <input />
                        <Label>{t("label_modal_€")}</Label>
                      </Input>
                    </Form.Field>
                  </Segment>
                </Form.Group>
              )}
            </Form>
            <Modal.Actions>
              <Button
                className="modalButtonAction"
                color="green"
                id="saveBtnMaterialModal"
                onClick={() => callback(this.state)}
              >
                <Icon name="checkmark" id="checkmarkIcon" />{" "}
                {t("button_modal_save")}
              </Button>
              <Button
                className="modalButtonAction"
                color="lightgrey"
                id="cancelBtnMaterialModal"
                onClick={this.handleClose}
              >
                <Icon name="remove" id="removeIcon" /> {t("button_modal_exit")}
              </Button>
            </Modal.Actions>
          </Modal.Description>
        </Modal.Content>
        <div class="ui divider" />
        {/* <Modal.Actions >

          <Button  onClick={() => callback(this.state)}>
            {t("button_modal_exit")}
          </Button>

          <Button >
            <Icon name="checkmark" id="checkmarkIcon" />
            {t("button_modal_save")}
          </Button>
        </Modal.Actions> */}
      </Modal>
    )
  }
}

export default translate("ModalMateriaux")(ModalMateriaux)



// WEBPACK FOOTER //
// ./src/components/Pro/Materiaux/ModalMateriaux.jsx